export const addDeliveryRevision = (checkups: any[]) => {
  const checkupsWithDeliveryRevision = [...checkups];
  if (checkupsWithDeliveryRevision.length > 0) {
    checkupsWithDeliveryRevision.splice(1, 0, {
      ...checkupsWithDeliveryRevision[0],
      title: 'Revisão de entrega',
      finished: false,
    });
  }
  return checkupsWithDeliveryRevision;
}